import React, { useCallback } from "react";

// Styles
// $FlowFixMe
import "./CheckBoxGroup.scss";

/*::
type Props = {
    handleClick: function,
    questionNumber: string,
	value: string[],
	options: string[],
	noneOptions ?: string
}
*/

// CheckBoxGroup Field Component
const CheckBoxGroup = (props /*: Props */) /*: any */ => {
	const checkTickValue = (values, label) => {
		return values.indexOf(label) > -1;
	};

	const handleCheck = useCallback(
		(value, checked) => {
			if (checked) {
				if (value === props.noneOption) {
					props.handleClick([value]);
				} else {
					props.handleClick(
						[...props.value, value].filter(
							(otherValue) => otherValue !== props.noneOption,
						),
					);
				}
			} else {
				props.handleClick(
					props.value.filter((otherValue) => value !== otherValue),
				);
			}
		},
		[props],
	);

	return (
		<div
			className={"checkbox-group question-" + props.questionNumber}
			data-cy={"input-q" + props.questionNumber}
		>
			{props.options.map((label /*: string */, index /*: number */) => (
				<label
					key={index}
					htmlFor={"checkbox-" + index}
					className="checkbox"
					data-cy={"label-" + index}
				>
					{label}
					<input
						checked={checkTickValue(props.value, label)}
						type="checkbox"
						id={"checkbox-" + index}
						data-cy={"checkbox-" + index}
						onChange={(e) => handleCheck(label, e.target.checked)}
						className={props.value === label ? "selected" : null}
						value={label}
					/>
					<span className="checkmark"></span>
				</label>
			))}
		</div>
	);
};

// Exports
export default CheckBoxGroup;
